// TODO: Remove this hook after the July production release.
export const useNewVerticalSideNav = () => {
  return true;
};
